export default __webpack_public_path__ + "static/media/bg39.b9b1c768.jpg";